import React from 'react';
//import Plans from '../components/ForYouAndYourFamilyNew/Plans';
import Plans from '../components/ForYouAndYourFamilyNew/PlansNew';
//import Contact from '../components/HomePageNew/Contact';
import Footer from '../components/HomePageNew/Footer';
import '../assets/css/plans_new.css';

const ForYouAndYourFamily = () => {

  return (
    <div>
      <Plans />
      {/* <Contact/> */}
      <Footer/>
    </div>
  );
};

export default ForYouAndYourFamily;



/** WEBPACK FOOTER **
 ** ./src/containers/ForYouAndYourFamilyNew.js
 **/